/**
 * ab项目关于流程中的常用枚举工具类
 */
import Vue from 'vue'
window.AbBpmGridUtil = {
  //初始化加载数据
  init: function () {
    window.AbBpmGridUtil.initSpeed = 0
    window.AbBpmGridUtil.initSuccess = false
    Vue.abTools
      .getEnum('com.dstz.bpm.api.constant.TaskType', true)
      .then((data) => {
        if (data.isOk === false) {
          return
        }
        window.AbBpmGridUtil.handleTaskType(data)
        if (++window.AbBpmGridUtil.initSpeed == 4) {
          window.AbBpmGridUtil.initSuccess = true
        }
      })
    // Vue.abTools.getEnum("com.dstz.bpm.api.constant.TaskStatus",true).then((data)=> {
    // 	if(data.isOk === false){
    // 		return;
    // 	}
    // 	window.AbBpmGridUtil.handleTaskStatus(data);
    // 	if(++window.AbBpmGridUtil.initSpeed == 4){
    // 		window.AbBpmGridUtil.initSuccess = true;
    // 	}
    // });
    // Vue.abTools.getEnum("com.dstz.bpm.api.constant.InstanceStatus",true).then((data)=> {
    // 	if(data.isOk === false){
    // 		return;
    // 	}
    // 	window.AbBpmGridUtil.handleInstanceStatus(data);
    // 	if(++window.AbBpmGridUtil.initSpeed == 4){
    // 		window.AbBpmGridUtil.initSuccess = true;
    // 	}
    // });
    // Vue.abTools.getEnum("com.dstz.bpm.api.constant.OpinionStatus",true).then((data)=> {
    // 	if(data.isOk === false){
    // 		return;
    // 	}
    // 	window.AbBpmGridUtil.handleOpinionStatus(data);
    // 	if(++window.AbBpmGridUtil.initSpeed == 4){
    // 		window.AbBpmGridUtil.initSuccess = true;
    // 	}
    // });
  },
  handleTaskStatus: function (TaskStatus) {
    let taskStatusValTextMap = {}
    let taskStatusValStyleMap = {}
    TaskStatus.forEach((item) => {
      if (item.labelCss == 'primary') {
        item.labelCss = 'processing'
      }
      taskStatusValTextMap[item.key] = item.value
      taskStatusValStyleMap[item.key] = item.labelCss || 'success'
    })
    window.AbBpmGridUtil.taskStatusValTextMap = taskStatusValTextMap
    window.AbBpmGridUtil.taskStatusValStyleMap = taskStatusValStyleMap
  },
  handleTaskType: function (TaskType) {
    let taskTypeValTextMap = {}
    let taskTypeValStyleMap = {}
    TaskType.forEach((item) => {
      taskTypeValTextMap[item.key] = item.value.replace('任务', '')
      taskTypeValStyleMap[item.key] = item.labelCss || 'success'
    })
    window.AbBpmGridUtil.taskTypeValTextMap = taskTypeValTextMap
    window.AbBpmGridUtil.taskTypeValStyleMap = taskTypeValStyleMap
  },
  handleInstanceStatus: function (InstanceStatus) {
    let instanceStatusValTextMap = {}
    let instanceStatusValStyleMap = {}
    InstanceStatus.forEach((item) => {
      if (item.labelCss == 'primary') {
        item.labelCss = 'processing'
      }
      instanceStatusValTextMap[item.key] = item.value
      instanceStatusValStyleMap[item.key] = item.labelCss || 'success'
    })
    window.AbBpmGridUtil.instanceStatusValTextMap = instanceStatusValTextMap
    window.AbBpmGridUtil.instanceStatusValStyleMap = instanceStatusValStyleMap
  },
  handleOpinionStatus: function (OpinionStatus) {
    let opinionStatusValTextMap = {}
    let opinionStatusValStyleMap = {}
    OpinionStatus.forEach((item) => {
      opinionStatusValTextMap[item.key] = item.value
      opinionStatusValStyleMap[item.key] = item.labelCss || 'success'
    })
    window.AbBpmGridUtil.opinionStatusValTextMap = opinionStatusValTextMap
    window.AbBpmGridUtil.opinionStatusValStyleMap = opinionStatusValStyleMap
  },
}

export default {
  // 全局安装时候
  install(Vue) {
    Vue.abBpmGridUtil = window.AbBpmGridUtil
    Vue.prototype.abBpmGridUtil = window.AbBpmGridUtil
  },
}
